import React, { Component } from 'react';
import './App.css';
import FeeTable from './FeeTable'

class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
      counter: 0,
      t:0,
    }
  }

  step(t) {
    this.setState({t: t})
    window.requestAnimationFrame((t) => this.step(t))
  }


  async componentDidMount() {
    document.title = "WhatTheFee.io - bitcoin feerate estimation"
    const cachebust = (new Date()/1e3/300).toFixed()*300
    const dataUrl = `/data.json?c=${cachebust}`
    let data = await fetch(dataUrl).then((r) => r.json());
    this.setState({
      'data': data
    })
  }

  render() {

    if(!this.state.data) {
      return (<div>Loading...</div>)
    }

    return (
      <div className="App">
        <header className="App-header">
          <h1 className="App-title">WhatTheFee.io - bitcoin feerate estimation</h1>

        </header>

        <p className="App-intro">

        </p>

        <div>
          <FeeTable dataframe={this.state.data}/>
        </div>

        <div style={{clear: "both"}} />

        <footer className="App-footer">
          created by <a rel="noopener noreferrer" target="_blank" href="https://twitter.com/FelixWeis">FelixWeis</a> / DM for feedback or free API keys
        </footer>


      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js